import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {RequestApiService} from "../../../services/domain_code/request-api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../common.service";
import {EmptyRepoQuoteTableService} from "../quoteTable/empty-repo-quote-table/empty-repo-quote-table.service";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {RequestQuotesChargesList} from "../quoteTable/base-quote.model";
import {ApiRoutes} from "../../../services/apiroutes";
import {WarningBoxComponent} from "../../dialog-box/warning-box/warning-box.component";
import {RequirementContainersComponent} from "./requirement-containers/requirement-containers.component";
import {GlobalLoaderService} from "../../../services/global-loader.service";
import {RequestDetailsBookingChargesService} from "../../../services/request-details-booking-charges.service";
import {ChargeDetailsComponent} from "./charge-details/charge-details.component";
import {environment} from "../../../../environments/environment";
import {map, of} from "rxjs";

@Component({
    selector: 'logzy-booking-charges',
    templateUrl: './booking-charges.component.html',
    styleUrls: ['./booking-charges.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
})
export class BookingChargesComponent implements OnInit {
    constructor(public requestService: RequestApiService,
                private route: ActivatedRoute,
                public commonService: CommonService,
                public emptyRepoQuoteService: EmptyRepoQuoteTableService,
                private dialog: MatDialog,
                private router: Router,
                private snackBar: MatSnackBar,
                private loaderService: GlobalLoaderService,
                private requestDetailsBookingChargesService: RequestDetailsBookingChargesService) {
        this.requestDetailsBookingChargesService.bookingDetailsUpdated$.subscribe(value => {
            this.bookingDetailsUpdated = value;
            // console.log('this is constructor1', this.bookingDetailsUpdated);
            if (this.bookingDetailsUpdated == true) {
                this.requirementChargesList = [];
                this.getRequestDetails();
                // console.log('this is constructor2 running getRequestDetails', this.bookingDetailsUpdated);
            }
        });
    }

    @Input() hideCharges: boolean = false;
    @Input() hideAddCharge: boolean = false;
    @Input() showActions: boolean = true;
    bookingDetailsUpdated: boolean;
    requestType: string;
    requestId;
    type: string = '';
    rtype: string = '';
    isEditable: boolean = false;
    currentDate = new Date();
    remarks: string;
    disableSaveButton: boolean = false;
    @Output() chargesAdded = new EventEmitter();
    @Output() reqContainers = new EventEmitter();
    @Output() addInvoiceParty = new EventEmitter();


    chargeColumns = ['charge_description', 'charge_type', 'quantity', 'total_amount', 'invoice_status', 'created_at'];
    chargeColumnsWithExpand = ['expand', ...this.chargeColumns];
    chargeChildColumns = ['charge_description', 'requirement', 'quantity', 'amount_per_unit', 'total_amount', 'invoice_status', 'created_at', 'action'];
    expandedElement: any | null;

    pageLength = 0;
    dropped: boolean = false;
    screenHeight: number;
    screenWidth: number;
    shadowX!: number;
    shadowY!: number;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('title') title: any;
    bookingChargesList;
    requirementChargesList: any[] = [];
    requirementContainersList;
    reqirementChargesDataSource

    consolidatedQuoteCharges: RequestQuotesChargesList[] = [];
    nonConsolidatedQuoteCharges: RequestQuotesChargesList[] = [];
    chargesDataSource;
    isCustomer: boolean;
    displayedColumnsCharges: string[] = [];
    currencyMaster_url = ApiRoutes.CurrencyMaster;
    currency_code: string = 'INR';
    company_url = `${ApiRoutes.Company}company/`;
    requestDetails;
    invoiceTypes;
    quoteList;
    disableSave: boolean = false;
    loading: boolean = false;
    chargeMaster_url = ApiRoutes.ChargeMaster;
    canvas: string = "Canvas";
    open1: string = "sidepanel";
    rentalToDate: string = '';
    showGenerateInvoice: boolean = false;
    billToId: string = '';

    ngOnInit(): void {
        this.requirementChargesList = [];
        this.route.queryParams.subscribe(params => {
            if ('id' in params || 'type' in params || 'rtype' in params) {
                this.requestId = params['id'];
                this.type = params['type'];
                this.rtype = params['rtype'];
            }
        });

        this.displayedColumnsCharges = ['charge_name', 'requirement', 'rec_amount', 'rec_total', 'rec_remark', 'actions'];
        // if (this.isCustomer) {
        // } else {
        //     this.displayedColumnsCharges = ['charge_name', 'requirement', 'pay_amount', 'paid_to', 'pay_remark', 'pay_total'];
        // }

        this.chargesDataSource = new MatTableDataSource<any>([]);
        // this.requestDetailsBookingChargesService.resetComponent$.subscribe(() => {
        // console.log('componenet reset triggered');
        //     this.getRequestDetails();
        // })
        this.getRequestDetails();
        this.getArthkoshInvoiceTypes();
        // console.log('this is oninit ', this.bookingDetailsUpdated)
        if (this.requestService.selectedRequest.is_booking_closed) {
            this.chargeChildColumns = this.chargeChildColumns.filter(col => col !== 'action');
        }
    }

    pageChanged(event: PageEvent) {
        console.log({event});
    }

    scrolltop() {
        setTimeout(() => {
            document.getElementById("top")?.scrollIntoView({block: "start", behavior: "smooth"});
        }, 200);
    }

    onMouseMove(e: any) {
        this.dropped = true;
        if (e.clientX < (this.screenWidth / 2)) {//right shadow
            this.shadowX = 5;
        } else if (e.clientX > (this.screenWidth / 2)) {//left shadow
            this.shadowX = -5;
        }
        if (e.clientY > (this.screenHeight / 2)) {//top shadow
            this.shadowY = -4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        } else if (e.clientY < (this.screenHeight / 2)) {//bottom shadow
            this.shadowY = 4;
            this.title.nativeElement.style.textShadow = `${this.shadowX}px ${this.shadowY}px 1px #b3bbbf`;
        }
    }

    // getRequestQuoteCharges() {
    //     this.requestService.getRequestQuoteCharges(this.rtype).subscribe(res => {
    //         if (res.length != 0) {
    //             this.consolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == true);
    //             this.nonConsolidatedQuoteCharges = res.filter(charge => charge.is_consolidated_charge == false);
    //         }
    //         this.populateCharges();
    //     })
    // }
    //
    // populateCharges() {
    //     let filteredChargesCon = this.consolidatedQuoteCharges.filter(item => item.auto_append_to_quotes == true);
    //     let filteredChargesNonCon = this.nonConsolidatedQuoteCharges.filter(item => item.auto_append_to_quotes == true);
    //
    //     console.log('this.consolidatedQuoteCharges', filteredChargesCon);
    //     console.log('this.nonConsolidatedQuoteCharges', filteredChargesNonCon);
    //
    //     let charges: any[] = [];
    //
    //     filteredChargesCon.map(item => {
    //         charges.push({
    //             requirement: null,
    //             charge_name: item,
    //             basis: item.charge.uom.description,
    //             rec_remarks: '',
    //             rec_amount: 0,
    //             rec_currency: 'INR',
    //             rec_total: 0,
    //             is_selected: false
    //         })
    //     });
    //
    //     this.quoteList.requirements.map((requirement) => {
    //         filteredChargesNonCon.map(item => {
    //             charges.push({
    //                 requirement: item.charge.uom.dev_value != 'job' ? requirement : null,
    //                 charge_name: item,
    //                 basis: item.charge.uom.description,
    //                 rec_remarks: '',
    //                 rec_amount: 0,
    //                 rec_currency: 'INR',
    //                 rec_total: 0,
    //                 is_selected: false
    //             })
    //         })
    //     });
    //
    //     charges.sort((a: any, b: any) => {
    //         if (a.requirement === null) return 1;
    //         if (b.requirement === null) return -1;
    //         return a.charge_name.id.localeCompare(b.charge_name.id);
    //     })
    //
    //     console.log('charges', charges);
    //
    //     this.chargesDataSource = new MatTableDataSource(charges);
    //
    // }

    saveCharges() {
        let chargeSelected = 0;
        let invalidCharge = 0, invalidCurrency = 0, invalidRequirementAndCurrency = 0;

        // this.chargesDataSource.data.map((data: any) => {
        //     if (data.is_selected == true) {
        //         chargeSelected++;
        //     }
        // });
        //
        // if (chargeSelected == 0) {
        //     this.openWarningDialog('Please select charges', '', 'Ok');
        //     this.disableSaveButton = false;
        //     return;
        // }

        this.chargesDataSource.data.map((data: any) => {
            if (data.charge == null) {
                invalidCharge++;
            }
        });

        if (invalidCharge > 0) {
            this.openWarningDialog('Please select charge', '', 'Ok');
            this.disableSaveButton = false;
            return;
        }

        this.chargesDataSource.data.map((data: any) => {
            if (data.charge != null) {
                if (data.charge?.uom?.dev_value == 'job') {
                    if (data.rec_currency == null) {
                        invalidCurrency++;
                    }
                }
            }
        });

        if (invalidCurrency > 0) {
            this.openWarningDialog('Please select currency', '', 'Ok');
            this.disableSaveButton = false;
            return;
        }

        this.chargesDataSource.data.map((data: any) => {
            if (data.charge != null) {
                if (data.charge?.uom?.dev_value == 'container') {
                    if (data.requirement == null || data.rec_currency == null) {
                        invalidRequirementAndCurrency++;
                    }
                }
            }
        });

        if (invalidRequirementAndCurrency > 0) {
            this.openWarningDialog('Please select requirement and currency', '', 'Ok');
            this.disableSaveButton = false;
            return;
        }

        console.log(this.chargesDataSource.data);
        this.generateJSON();
    }

    async generateJSON() {
        const requirementCharges = this.chargesDataSource.data
            .map((charge: any) => {
                const containerCharges = charge.requirement != null
                    ? this.requirementContainersList
                        .filter(container => container.requirement === charge.requirement.requirement)
                        .map(container => ({
                            charge_description: charge.charge.print_name,
                            total_amount: charge.requirement?.quantity != 0 ? Number(charge.rec_total.toFixed(12)) / Number(charge.charge.uom.dev_value != 'job' ? charge.requirement?.quantity : 1) : 0,
                            charge: charge.charge.id
                        }))
                    : [];

                return {
                    requirement: charge.requirement != null ? charge.requirement.requirement : null,
                    charge_description: charge.charge.charge_head,
                    basis: charge.charge.uom.dev_value,
                    term: 'prepaid',
                    quantity: charge.charge.uom.dev_value != 'job' ? charge.requirement?.quantity : 1,
                    total_amount: charge.rec_total.toFixed(12),
                    currency: charge.rec_currency,
                    remarks: charge.rec_remarks,
                    charge: charge.charge.id,
                    booking_requirement: charge.requirement != null ? charge.requirement.id : null,
                    container_charges: charge.charge.uom.dev_value != 'job' ? containerCharges : []
                };
            });

        console.log('requirementCharges', requirementCharges);

        const groupedCharges = new Map<string, any>();

        requirementCharges.forEach(charge => {
            if (!groupedCharges.has(charge.charge)) {
                groupedCharges.set(charge.charge, {
                    requirement_charges: [],
                    charge_description: charge.charge_description,
                    charge_type: charge.basis,
                    quantity: 0,
                    currency: charge.currency,
                    total_amount: "0.000000000000",
                    booking: this.requestDetails.booking,
                    charge: charge.charge
                });
            }

            const bookingCharge = groupedCharges.get(charge.charge)!;
            charge.basis != 'job' ? bookingCharge.requirement_charges.push(charge) : bookingCharge.requirement_charges;
            bookingCharge.quantity += charge.quantity;
            bookingCharge.total_amount = (parseFloat(bookingCharge.total_amount) + parseFloat(charge.total_amount)).toFixed(12);
        });


        const booking_charges = Array.from(groupedCharges.values())
        console.log('bookingCharges', booking_charges);

        const errorList: { charge: any; error: string }[] = [];

        for (const charge of booking_charges) {
            try {
                await this.requestService.postBookingCharges(charge).toPromise();
                this.ngOnInit();
            } catch (error: any) {
                errorList.push({charge: charge, error: error});
            }
        }

        console.log(errorList);

        // this.requestService.postBookingCharges(booking_charges).subscribe({
        //     next: response => {
        //         this.snackBar.open('Booking Charges Added', 'Close', {
        //             verticalPosition: 'top',
        //             duration: 3000,
        //         });
        //
        //         this.disableSaveButton = false;
        //         this.ngOnInit();
        //     },
        //     error: error => {
        //         console.log('error', error);
        //         this.disableSaveButton = false;
        //         if (error.status >= 500) {
        //             this.snackBar.open('Something went wrong!! Please try again after sometime.', 'Close', {
        //                 verticalPosition: 'top',
        //                 duration: 5000,
        //             });
        //         } else if (error.status > 399 && error.status < 500) {
        //             return error;
        //         }
        //     }
        // });
    }

    openWarningDialog(label
                          :
                          string, description, action1
                          :
                          string, action2 ?: string, action3
                          :
                          string = null
    ) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {
                subTitle: label,
                parent: this,
                description: description,
                label1: action1,
                label2: action2,
                label3: action3
            }
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
            }
        })
    }

    setRecTotal(data: any) {
        data.rec_total = data.requirement != null ? (Number(data.rec_amount) * Number(data.requirement?.quantity)) : Number(data.rec_amount);
    }

    setTotalUpdate(data: any) {
        data.total_amount = Number(data.amount_per_unit) * Number(data.quantity);
    }

// updateChargesCurrency(data: any) {
//     this.chargesDataSource.data.map((charge: any) => {
//         if (charge.charge_name.id == data.charge_name.id) {
//             charge.rec_currency = data.rec_currency;
//         }
//     })
// }

    getRequestDetails() {
        this.loaderService.showLoader();
        this.requestService.getRequestDetailsById(this.requestId).subscribe({
            next: response => {
                this.requestDetails = response;
                this.requestService.selectedRequest = {...response};
                // this.requestService.requirementList = this.requestService.selectedRequest.requirement;
                this.getLastQuote();
            },
            error: error => {
                this.loaderService.hideLoader();
                return error;
            }
        })
    }

    getArthkoshInvoiceTypes() {
        this.loaderService.showLoader();
        this.requestService.getInvoiceTypesFromArthakosh().subscribe({
            next: response => {
                this.invoiceTypes = response;
                this.loaderService.hideLoader();
            },
            error: error => {
                this.loaderService.hideLoader();
                return error;
            }
        })
    }

    getLastQuote() {
        this.requestService.getBookingDetailsById(this.requestDetails.booking).subscribe({
            next: response => {
                // this.requestService.requirementList = response.requirements;
                this.quoteList = response;
                console.log('this.quoteList', this.quoteList);
                // this.getRequestQuoteCharges();
                this.getBookingChargeDetails();
                this.getAllRequirementsAndContainers();
            },
            error: error => {
                this.loaderService.hideLoader();
                return error;
            }
        });
    }

    getBookingChargeDetails() {
        this.requestService.getBookingChargeDetailsById(this.requestDetails.booking).subscribe({
            next: response => {
                console.log('booking charge details', response.results)
                response.results.map((booking: any) => {
                    if (booking.charge_type == 'job') {
                        const charge = {
                            charge: booking.charge,
                            charge_description: booking.charge_description,
                            booking_charge: booking.id,
                            particulars: '-',
                            amount_per_unit: Number(Number(booking.total_amount) / Number(booking.quantity)).toFixed(2),
                            currency: booking.currency,
                            total_amount: Number(booking.total_amount),
                            quantity: Number(booking.quantity),
                            invoice_status: booking.invoice_status,
                            created_at: booking.created_at,
                            charge_type: booking.charge_type,
                            edit: false,
                            container_charges: []
                        }
                        this.requirementChargesList.push(charge);
                    } else {
                        booking.requirement_charges.map((requirementCharge: any) => {
                            requirementCharge.amount_per_unit = requirementCharge.quantity != 0 ? (Number(requirementCharge.total_amount) / Number(requirementCharge.quantity)).toFixed(2) : 0;
                            requirementCharge.currency = booking.currency;
                            requirementCharge.charge_type = booking.charge_type;
                            requirementCharge.edit = false;
                            requirementCharge.container_charges.map((containerCharge: any) => containerCharge.currency == requirementCharge.currency);

                            let lowestStartDate = '', highestEndDate = '';
                            if (requirementCharge.container_charges.length != 0) {
                                lowestStartDate = requirementCharge.container_charges.reduce((min, item) =>
                                    new Date(item.from_date) < new Date(min) ? item.from_date : min, requirementCharge.container_charges[0].from_date);
                                highestEndDate = requirementCharge.container_charges.reduce((max, item) =>
                                    new Date(item.to_date) > new Date(max) ? item.to_date : max, requirementCharge.container_charges[0].to_date);
                            }

                            requirementCharge.lowestStartDate = lowestStartDate;
                            if (highestEndDate != '') {
                                const endDate = new Date(highestEndDate);
                                endDate.setSeconds(endDate.getSeconds() - 1);
                                requirementCharge.highestEndDate = new Date(requirementCharge.lowestStartDate) > new Date(endDate) ? requirementCharge.lowestStartDate : endDate;
                            }

                            this.requirementChargesList.push(requirementCharge);
                        })
                    }
                });
                this.loaderService.hideLoader();
                const value = this.requirementChargesList.find(item => item.invoice_status == 'Pending');
                this.showGenerateInvoice = value != undefined;
                this.reqirementChargesDataSource = new MatTableDataSource(this.requirementChargesList.filter((charge: any) => charge.quantity != 0));
                console.log('reqirementChargesDataSource', this.reqirementChargesDataSource);
            },
            error: error => {
                this.loaderService.hideLoader();
                return error;
            }
        })
    }

    getAllRequirementsAndContainers() {
        this.requestService.getAllRequirementsAndContainers(this.requestId).subscribe({
            next: (response: any) => {
                console.log('getAllRequirementsAndContainers', response);
                this.requirementContainersList = response;
                return response;
            },
            error: error => {
                return error;
            }
        })
    }

    viewContainers(containers) {
        const dialogData = {
            containersList: containers.container_charges
        };
        const dialogRef = this.dialog.open(RequirementContainersComponent, {
            // width: '50%',
            disableClose: true,
            data: dialogData
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {

            } else {

            }
        });
    }

    addNewCharge() {
        const emptyRow = {
            charge: null,
            basis: null,
            requirement: null,
            rec_amount: 0,
            rec_currency: 'INR',
            rec_total: 0,
            rec_remarks: ''
        };

        this.chargesDataSource.data = [...this.chargesDataSource.data, emptyRow];
    }

    deleteRow(index: number) {
        const data = [...this.chargesDataSource.data];
        data.splice(index, 1);
        this.chargesDataSource.data = data;
    }

    updateAmount(requirement: any) {
        requirement.edit = true;
    }

    async saveRequirement(data: any) {
        this.loaderService.showLoader();
        console.log(data);
        let reqCharge: any[] = [], containerCharges: any[] = [];
        reqCharge.push(data);

        reqCharge
            .map((charge: any) => {
                charge.container_charges.map(container =>
                    container.total_amount = Number(charge.amount_per_unit).toFixed(12)
                );
            });

        const requirementCharges = reqCharge.map(quote => ({
            ...quote,
            container_charges: quote.container_charges.map(({id, charge, charge_description, total_amount}) => ({
                id,
                charge,
                charge_description,
                total_amount
            }))
        }));


        let bookingCharge;
        requirementCharges.map(charge => {
            bookingCharge = {
                requirement_charges: charge.charge_type != 'job' ? requirementCharges : [],
                charge_description: charge.charge_description,
                charge_type: charge.charge_type,
                quantity: charge.quantity,
                total_amount: charge.total_amount,
                currency: charge.currency,
                booking: this.requestDetails.booking,
                charge: charge.charge
            }
        });

        console.log('bookingCharge', bookingCharge);

        const errorList: { charge: any; error: string }[] = [];
        try {
            await this.requestService.updateRequirement(data.booking_charge, bookingCharge).toPromise();
            this.loaderService.hideLoader();
            this.snackBar.open('Requirement updated successfully', 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            this.ngOnInit();
        } catch (error: any) {
            this.loaderService.hideLoader();
            errorList.push({charge: bookingCharge, error: error});
        }
    }

    showContainers(data: any) {
        this.reqContainers.emit(data);
    }

    async deleteRequirement(data: any) {
        console.log(data);
        let reqCharge: any[] = [], containerCharges: any[] = [];
        reqCharge.push(data);

        reqCharge
            .map((charge: any) => {
                charge.container_charges.map(container => {
                        container.total_amount = Number(charge.amount_per_unit).toFixed(12);
                        container.is_active = false
                    }
                );
                charge.is_active = false;
            });

        const requirementCharges = reqCharge.map(quote => ({
            ...quote,
            container_charges: quote.container_charges.map(({
                                                                id,
                                                                charge,
                                                                charge_description,
                                                                total_amount,
                                                                is_active
                                                            }) => ({
                id,
                charge,
                charge_description,
                total_amount,
                is_active
            }))
        }));

        let bookingCharge;
        requirementCharges.map(charge => {
            bookingCharge = {
                requirement_charges: charge.charge_type != 'job' ? requirementCharges : [],
                charge_description: charge.charge_description,
                charge_type: charge.charge_type,
                quantity: charge.quantity,
                total_amount: charge.total_amount,
                currency: charge.currency,
                booking: this.requestDetails.booking,
                charge: charge.charge
            }
        });

        console.log('bookingCharge', bookingCharge);

        const errorList: { charge: any; error: string }[] = [];
        try {
            await this.requestService.deleteRequirement(data.booking_charge, bookingCharge).toPromise();
            this.snackBar.open('Requirement deleted successfully', 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
            this.ngOnInit();
        } catch (error: any) {
            errorList.push({charge: bookingCharge, error: error});
        }

        console.log(errorList);
    }

    fetchRentalDetails() {
        if (this.rentalToDate == "") {
            this.snackBar.open('Select to date', 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
        } else {
            this.loaderService.showLoader();
            this.requestService.getRentalDetails(this.requestService?.selectedRequest?.booking, this.rentalToDate).subscribe({
                next: (response: any) => {
                    this.loaderService.hideLoader();
                    console.log('getRentalDetails', response);
                    const dialogData = {
                        chargeData: response
                    };
                    const dialogRef = this.dialog.open(ChargeDetailsComponent, {
                        disableClose: true,
                        data: dialogData
                    });

                    dialogRef.afterClosed().subscribe(result => {
                        if (result) {
                        } else {

                        }
                        this.ngOnInit();
                    });
                },
                error: error => {
                    console.log('error', error);
                }
            })
        }
    }

    getBackgroundColor(status: string) {
        switch (status) {
            case 'Pending':
                return '#949494';
            case 'Proforma':
                return '#b26c02';
            case 'Invoiced':
                return '#f05f25';
            case 'Void':
                return '#5d0000';
            case 'Waived':
                return '#2f2d2d';
        }
    }

    generateInvoice() {
        let invoiceType = this.invoiceTypes.results.filter(item => item.dev_name == 'export');
        let booking = this.quoteList.arthakosh_booking_id;
        let subBooking = this.quoteList.arthakosh_id;
        let billTo = '';

        if (invoiceType.length != 0) {
            let invoiceId = null, bookingId = null, subBookingId = null;

            of(invoiceType[0].id).pipe(
                map(str => str.replace(/-/g, ''))
            ).subscribe(result => invoiceId = result);
            of(booking).pipe(
                map(str => str.replace(/-/g, ''))
            ).subscribe(result => bookingId = result);
            of(subBooking).pipe(
                map(str => str.replace(/-/g, ''))
            ).subscribe(result => subBookingId = result);
            of(invoiceType[0].stakeholder_type).pipe(
                map(str => str.replace(/-/g, ''))
            ).subscribe(result => billTo = result);


            const url = `/invoice/autoGenerateDraft?invoice_type_id=${invoiceId}&booking_id=${bookingId}&sub_booking_id=${subBookingId}&bill_to_id=${billTo}&auto_draft_charge_group_id=null`;
            let encodedUrl = encodeURIComponent(url);

            console.log("encoded", environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl)

            window.open(environment.arthakoshFrontendBaseUrl + '/authentication/handshake/?url=' + encodedUrl, '_blank');

        } else {
            this.snackBar.open('Invoice type not found', 'Close', {
                verticalPosition: 'top',
                duration: 3000,
            });
        }
    }

    invoiceParty(data: any) {
        this.addInvoiceParty.emit(data);
    }
}
